import { Environment } from 'relay-runtime';
import { getDefaultRelayEnvironmentConfig } from '@atlassian/relay-environment-config';
export function createRelayEnvironment(_ref) {
  var log = _ref.log,
    requiredFieldLogger = _ref.requiredFieldLogger;
  return new Environment(getDefaultRelayEnvironmentConfig({
    log: log,
    requiredFieldLogger: requiredFieldLogger
  }));
}
export var AtlassianRelayEnvironment = createRelayEnvironment({});